import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchSubscribeOption } from '@/services/subscribe';

/**
 * 获取预约项目和预约状态数据
 * - option_list 预约项目
 * - status_list 预约状态
 * - update_status_list
 更新状态
 */
const useSubscribeOption = () => {
  const { subscribeOption, setSubscribeOption } = useReadyInfo();

  const {
    run: getSubscribeOptionStatus,
    data,
    loading,
  } = useRequest(fetchSubscribeOption, { manual: true });

  useEffect(() => {
    if (
      !subscribeOption ||
      !subscribeOption?.option_list ||
      !subscribeOption?.status_list ||
      !subscribeOption?.update_status_list
    ) {
      getSubscribeOptionStatus().then((res) =>
        setSubscribeOption({
          option_list:
            res?.option_list?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          status_list:
            res?.status_list?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          update_status_list:
            res?.update_status_list?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
        })
      );
    }
  }, [subscribeOption]);

  return {
    data: subscribeOption || {
      option_list:
        data?.option_list?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      status_list:
        data?.status_list?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      update_status_list:
        data?.update_status_list?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
    },
    loading,
  };
};

export default useSubscribeOption;
